<template>
  <li>
    <button
        :class="isActive ? 'button--selected' : ''"
        class="button button--filter"
        @click="handleClick"
    >
      {{ tag.TagName }}
    </button>
  </li>
</template>

<script>
export default {
  name: "FilterTagsList",
  props: {
    tag: Object,
    isActive: Boolean,
  },
  methods: {
    handleClick() {
      this.$emit("onFilterClick", this.tag.TagId);
    }
  }
};
</script>
